import { Injectable } from '@angular/core';
import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { CustomAppInsightProp } from 'common/models/appinsights-model/custom-insights';
import { ConfigService } from '../config.service';

@Injectable(
)
export class AppInsightsLoggingService {
  appInsights: ApplicationInsights;
  constructor(private configService: ConfigService) {
    const checkInterval = setInterval(() => {
      if (window['config'].appInsights) {
        this.loadAppInsights();
        clearInterval(checkInterval);
      }
    });
  }

  loadAppInsights() {
    if (this.configService?.appInsightsKey == '') {
      return;
    }
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: this.configService?.appInsightsKey,
        enableAutoRouteTracking: true, // option to log all route changes
        distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
        autoTrackPageVisitTime: true,
        enableAjaxErrorStatusText: true
      }
    });
    this.appInsights.loadAppInsights();
  }

  getWindow(): any {
    return window;
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights?.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights?.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights?.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: any, severityLevel?: number) {
    this.appInsights?.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights?.trackTrace({ message: message }, properties);
  }

  public loadCustomTelemetryProperties(customAppInsight: CustomAppInsightProp) {
    this.appInsights.addTelemetryInitializer(envelope => {
      var customProdEnvelope = envelope.baseData;
      customProdEnvelope.properties = customProdEnvelope.properties || {};
      customProdEnvelope.properties["ApplicationPlatform"] = customAppInsight.platformName;
      customProdEnvelope.properties["ApplicationName"] = customAppInsight.applicationName;
      customProdEnvelope.properties["LogType"] = customAppInsight.logType;
      customProdEnvelope.properties["RequestUrl"] = customAppInsight.url;
      customProdEnvelope.properties["RequestBody"] = customAppInsight.request;
      customProdEnvelope.properties["ResponseBody"] = customAppInsight.response;
      customProdEnvelope.properties["IsRequestSuccessful"] = customAppInsight.isRequestSuccessful;
      customProdEnvelope.properties["LogInfo"] = customAppInsight?.logInfo;
      customProdEnvelope.properties["SessionId"] = customAppInsight?.sessionId ?? sessionStorage.getItem("sessionId");
    });
  }
}